<div class="container">
  <div class="row d-flex justify-content-between">
    <nav aria-label="breadcrumb" class="breadcrumb_case">
      <ol class="breadcrumb">
        <li class="pointer" (click)="goBack()"> <span><img src="../../../assets/images/leftArrow.svg" class="me-2"
              alt=""></span></li>
        <li class="breadcrumb-item fs-16 fw-400 pointer" [routerLink]="'/home'">Home</li>
        <li class="breadcrumb-item fs-16 fw-400 pointer" [routerLink]="'/resources'">Resource Center</li>
        <li class="breadcrumb-item fs-16 fw-400 pointer" [routerLink]="'/resources/'+ activeCase">{{activeCase ==
          'circular-information'? 'Circulars & Information': activeCase ==
          'case-study' ? 'Case Study' : 'Wall of Fame' }}</li>
        <li class="breadcrumb-item fs-16 fw-400 pointer active"> {{case?.title}} </li>
      </ol>
    </nav>
    <ng-container *ngIf="case && activeCase !=
    'wall-of-fame'">

      <!-- <div class="shadow p-3 mb-5 bg-white rounded">
        Large shadow
      </div> -->

      <!-- <pre>{{ case | json }}</pre> -->
      <div>
        <div>
          <h3 class="fs-24 fw-400 title">{{case?.title | titlecase}}</h3>
          <!-- <p class="fs-14 fw-400 sub-title">{{case?.source}}</p> -->
        </div>

        <div class="d-flex flex-row justify-content-between align-items-center gap-3">
          <div class="flex-grow-1">
            <div class="d-flex flex-row gap-3">
                <p class="fs-12 fw-600 text-muted">Posted on: <span class="text-dark">{{case?.publishedDate | date:'longDate': 'MMMM d, y' }}</span></p>
                <p class="fs-12 fw-600 text-muted">Author: <span class="text-dark">{{case?.publishedBy| titlecase}}</span></p>
            </div>
          </div>

          <div>
            <ng-container *ngIf="!(activeCase == 'circular-information')">
              <div class="file shadow d-inline-block" (click)="openDialog(case?.fileList)" *ngIf="case?.fileList?.length>0">
                <svg class="tabs_icon" width="16" height="16" viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M9.50065 1.66667C9.50065 1.62246 9.48309 1.58007 9.45184 1.54882C9.42058 1.51756 9.37819 1.5 9.33398 1.5H4.66732C4.18109 1.5 3.71477 1.69315 3.37096 2.03697C3.02714 2.38079 2.83398 2.8471 2.83398 3.33333V12.6667C2.83398 13.1529 3.02714 13.6192 3.37096 13.963C3.71477 14.3068 4.18109 14.5 4.66732 14.5H11.334C11.8202 14.5 12.2865 14.3068 12.6303 13.963C12.9742 13.6192 13.1673 13.1529 13.1673 12.6667V6.098C13.1673 6.0538 13.1498 6.01141 13.1185 5.98015C13.0872 5.94889 13.0449 5.93133 13.0007 5.93133H10.0007C9.86804 5.93133 9.74087 5.87865 9.6471 5.78489C9.55333 5.69112 9.50065 5.56394 9.50065 5.43133V1.66667ZM10.0007 8.16667C10.1333 8.16667 10.2604 8.21935 10.3542 8.31311C10.448 8.40688 10.5007 8.53406 10.5007 8.66667C10.5007 8.79928 10.448 8.92645 10.3542 9.02022C10.2604 9.11399 10.1333 9.16667 10.0007 9.16667H6.00065C5.86804 9.16667 5.74087 9.11399 5.6471 9.02022C5.55333 8.92645 5.50065 8.79928 5.50065 8.66667C5.50065 8.53406 5.55333 8.40688 5.6471 8.31311C5.74087 8.21935 5.86804 8.16667 6.00065 8.16667H10.0007ZM10.0007 10.8333C10.1333 10.8333 10.2604 10.886 10.3542 10.9798C10.448 11.0735 10.5007 11.2007 10.5007 11.3333C10.5007 11.4659 10.448 11.5931 10.3542 11.6869C10.2604 11.7807 10.1333 11.8333 10.0007 11.8333H6.00065C5.86804 11.8333 5.74087 11.7807 5.6471 11.6869C5.55333 11.5931 5.50065 11.4659 5.50065 11.3333C5.50065 11.2007 5.55333 11.0735 5.6471 10.9798C5.74087 10.886 5.86804 10.8333 6.00065 10.8333H10.0007Z"
                    fill="white" />
                  <path
                    d="M10.5 1.88247C10.5 1.75981 10.6287 1.68181 10.724 1.75848C10.8047 1.82381 10.8773 1.89981 10.9393 1.98648L12.948 4.78448C12.9933 4.84848 12.944 4.93114 12.8653 4.93114H10.6667C10.6225 4.93114 10.5801 4.91358 10.5488 4.88233C10.5176 4.85107 10.5 4.80868 10.5 4.76447V1.88247Z"
                    fill="white" />
                </svg>
                {{case?.title | titlecase}}
              </div>
              <span class="fs-12 fw-400" *ngIf="!case?.fileList?.length">No files attached.</span>
            </ng-container>
          </div>
        </div>
      </div>


      <!-- <div class="container">
        <div class="row">
          <div class="col-md-12 d-flex justify-content-between">

            <div>
              <div class="fs-14 fw-500" *ngIf="">File</div>
            </div>


    </div>
  </div>
</div> -->

      <div class="col-md-12 d-flex flex-row mt-3">
        <div class="me-5 mb-auto">
          <p class="fs-14">{{ case?.description }}</p>
        </div>

        <div class="case-study align-self-start ms-auto">

          <img src="../../../assets/images/case-studies-page.png" alt="">
        </div>
      </div>


    </ng-container>
    <div *ngIf="case && activeCase ==
    'wall-of-fame'">
      <section class="wallFame product">
        <div class="row">
          <div class="col-lg-9">
            <h5 class="fs-24 fw-400 col-auto mt-3">{{case?.title}}</h5>
            <div style="display: flex;">
              <img src="../../../../assets/location.png" alt="location" style="width: 17px;
              height: 17px;
              margin-top: 8px;" />
              <p style="font-size: 12px; margin: 0;" class="mt-2">{{case?.documentSource ? case?.documentSource : 'Uttar Pradesh'}}</p>
            </div>
            <div class="card mt-3 mb-3 border-0">
              <div class="card-body">
                <p style="margin: 0; font-weight: 700;">Description</p>
                <p style="margin: 0; font-size: 12px; color: gray;" class="pt-2">{{case?.description ? case?.description : 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Excepturi laborum, quia veritatis porro accusantium iste delectus fuga praesentium, assumenda dicta facilis similique magni cupiditate dolorum architecto tempora nulla nemo modi. Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae ipsa deleniti accusantium quibusdam culpa veritatis ullam voluptatem iste reiciendis? Ipsa illo obcaecati officia quidem ab nam rem officiis voluptatum libero.Lorem ipsum dolor sit, amet consectetur adipisicing elit. Excepturi laborum, quia veritatis porro accusantium iste delectus fuga praesentium, assumenda dicta facilis similique magni cupiditate dolorum architecto tempora nulla nemo modi. Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae ipsa deleniti accusantium quibusdam culpa veritatis ullam voluptatem iste reiciendis? Ipsa illo obcaecati officia quidem ab nam rem officiis voluptatum libero.Lorem ipsum dolor sit, amet consectetur adipisicing elit. Excepturi laborum, quia veritatis porro accusantium iste delectus fuga praesentium, assumenda dicta facilis similique magni cupiditate dolorum architecto tempora nulla nemo modi. Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae ipsa deleniti accusantium quibusdam culpa veritatis ullam voluptatem iste reiciendis? Ipsa illo obcaecati officia quidem ab nam rem officiis voluptatum libero.Lorem ipsum dolor sit, amet consectetur adipisicing elit. Excepturi laborum, quia veritatis porro accusantium iste delectus fuga praesentium, assumenda dicta facilis similique magni cupiditate dolorum architecto tempora nulla nemo modi. Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae ipsa deleniti accusantium quibusdam culpa veritatis ullam voluptatem iste reiciendis? Ipsa illo obcaecati officia quidem ab nam rem officiis voluptatum libero.Lorem ipsum dolor sit, amet consectetur adipisicing elit. Excepturi laborum, quia veritatis porro accusantium iste delectus fuga praesentium, assumenda dicta facilis similique magni cupiditate dolorum architecto tempora nulla nemo modi. Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae ipsa deleniti accusantium quibusdam culpa veritatis ullam voluptatem iste reiciendis? Ipsa illo obcaecati officia quidem ab nam rem officiis voluptatum libero.'}}</p>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <img [src]="case?.fileList[0].fileUrl" alt="image" class="img-fluid user_wall w-100"/>
          </div>
        </div>
      </section>
    </div>

  </div>
</div>


<section *ngIf="studyCard?.length && activeCase !=
'wall-of-fame'" class="slider_section" style="margin-top: 70px;">
  <div class="text-center fs-24 fw-400 mb-4">{{ activeCase == 'circular-information' ? 'Other Circulars & Information' :
    'Other Case Studies' }}</div>
  <div class="container-fluid pe-0 overflow-hidden">
    <div class="slider-wrap">
      <!-- style="display: flex; overflow-x: auto;" -->

      <div class="slider-main d-flex gap-1 flex-nowrap">
        <div class="item mb-3" *ngFor="let item of studyCard" (click)="navigateToCaseStudy(item)">
          <!-- style="flex: 0 0 auto; width: 25%;" -->

          <div class="card h-100 shadow-sm border-0 pointer" style="width: 300px;">
            <div class="card-body pb-0">
              <h5 class="fs-14 fw-600" style="height: 12%;">{{ item?.title | titlecase }}</h5>
              <p style="font-size: 11px; height: 25%;">{{ item?.description | slice : 0:50 }}</p>
              <div class="d-flex justify-content-between mb-1">
                <div class="fs-12 fw-400"><span><img src="assets/images/calendar-shg.svg"
                      class="img-fluid icons_alignment" alt=""></span>{{ item?.publishedDate | date : 'shortDate' }}
                </div>
                <div class="fs-12 fw-400"><span><img src="assets/images/folder-shg.svg"
                      class="img-fluid icons_alignment" alt=""></span>{{ item?.source }}</div>
              </div>
              <p class="fs-12 fw-400 color-grey">By {{ item?.publishedBy }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="button_area d-flex">
        <button class="btn prev text-white" (click)="previousSlide()">
          <img src="../../../../assets/images/prevIcon-shg.svg" class="img-fluid" alt="">
        </button>
        <button class="btn next text-white" (click)="nextSlide()">
          <img src="../../../../assets/images/nextIcon-svg.svg" class="img-fluid" alt="">
        </button>
      </div>
    </div>
  </div>
</section>

<section *ngIf="studyCard?.length && activeCase ==
'wall-of-fame'" class="slider_section" style="margin-top: 70px;">
  <div class="text-center fs-24 fw-400 mb-4">Other Wall of Fame</div>
  <div class="container-fluid pe-0 overflow-hidden">
    <div class="slider-wrap">
      <!-- style="display: flex; overflow-x: auto;" -->
      <div class="slider-main d-flex gap-2 flex-nowrap">
        <div style="border-radius: 5px; cursor: pointer" class="item col-lg-3 mb-4" *ngFor="let item of studyCard" (click)="navigateToCaseStudy(item)">
          <div style="width: 100%;">
            <img [src]="item?.fileList[0]?.fileUrl" class="img-fluid w-100 slider-img br-4" alt="img">
          </div>
          <div class="detail bg-white">
            <div class="name fs-16 fw-600">{{item.title}}</div>
            <div class="designation fs-12 fw-400 color-grey mb-1">{{item.documentSource}}</div>
          </div>
        </div>
      </div>

      <div class="button_area d-flex">
        <button class="btn prev text-white" (click)="previousSlide()">
          <img src="../../../../assets/images/prevIcon-shg.svg" class="img-fluid" alt="">
        </button>
        <button class="btn next text-white" (click)="nextSlide()">
          <img src="../../../../assets/images/nextIcon-svg.svg" class="img-fluid" alt="">
        </button>
      </div>
    </div>
  </div>
</section>
